import _ from 'lodash';
import React from 'react';
import styled from '@emotion/styled';

import RichText from '@/components/rich-text';
import Icon, { iconNames } from '@/components/icons';
import { COLORS, BREAKPOINTS, SPACE } from '@/constants';
import { logTrackingEvent } from '@/utils/tracking';

const CalloutWrapper = styled.div`
  background-color: ${COLORS.BRAND_NAVY_ONE};
  border-radius: 0;
  color: ${COLORS.GREY_ELEVEN};
  display: flex;
  flex-direction: column;
  padding: ${SPACE.X1};

  @media (min-width: ${BREAKPOINTS.SM}px) {
    flex-direction: row;
  }
`;

const StyledContent = styled.span`
  align-items: center;
  display: flex;
  padding-left: ${SPACE.X1};
`;

const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: ${SPACE.X1};

  @media (min-width: ${BREAKPOINTS.SM}px) {
    padding-bottom: 0;
  }
`;

const StyledRichText = styled(RichText)`
  p {
    margin: 0;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'didYouKnowTips' implicitly has an 'any' type.
const getRandomTipContent = (didYouKnowTips) => _.sample(didYouKnowTips).body;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'didYouKnowTips' implicitly has an 'any' type.
const DidYouKnowCallout = ({ didYouKnowTips }) =>
  !_.isEmpty(didYouKnowTips) && (
    <CalloutWrapper onClick={() => logTrackingEvent({ event: 'didYouKnowCallout' })}>
      <IconWrapper>
        <Icon name={iconNames.didYouKnow} />
      </IconWrapper>
      <StyledContent>
        <StyledRichText>{getRandomTipContent(didYouKnowTips)}</StyledRichText>
      </StyledContent>
    </CalloutWrapper>
  );

export default DidYouKnowCallout;
